import React from 'react';
import { Stack, Typography } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { WidgetCard, WidgetEmptyState } from './WidgetCard';

const formatValue = (value) => {
  if (value == null || Number.isNaN(value)) return 'N/A';
  if (typeof value === 'number') return value.toLocaleString();
  return String(value);
};

const KpiDeltaWidget = ({ widget, metric, metrics }) => {
  const { title, metricId, compareMetricId } = widget.params || {};
  const current = metric?.value;
  const compare = compareMetricId ? metrics?.[compareMetricId]?.value : null;
  const delta =
    typeof current === 'number' && typeof compare === 'number' ? current - compare : null;

  return (
    <WidgetCard
      title={title || 'KPI Delta'}
      subtitle={metricId}
      testId={`report-widget-${widget.id || widget.type}`}
    >
      {current == null ? (
        <WidgetEmptyState message="Delta values appear after query execution." />
      ) : (
        <Stack spacing={1}>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            {formatValue(current)}
          </Typography>
          {delta != null && (
            <Stack direction="row" spacing={1} alignItems="center">
              {delta >= 0 ? (
                <ArrowUpwardIcon fontSize="small" color="success" />
              ) : (
                <ArrowDownwardIcon fontSize="small" color="error" />
              )}
              <Typography variant="body2" color={delta >= 0 ? 'success.main' : 'error.main'}>
                {delta >= 0 ? '+' : ''}{formatValue(delta)}
              </Typography>
            </Stack>
          )}
        </Stack>
      )}
    </WidgetCard>
  );
};

export default KpiDeltaWidget;
